import { Box, Typography, TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { RecommendationType } from "../../enums";

export const HeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "type",
})<{ type?: RecommendationType }>(({ theme, type }) => ({
  display: "flex",
  width: "calc(100%)",
  paddingBottom: theme.spacing(1.5),
  justifyContent: "space-between",
  marginLeft:
    type === RecommendationType.BASKET ||
    type === RecommendationType.SEARCH_START_TOPPICKS
      ? "0px"
      : "-8px",
}));

export const HeaderTitleContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
})) as typeof Box;

interface TitleTextProps extends TypographyProps {
  showTitleIcon?: boolean;
}

export const TitleText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "showTitleIcon",
})<TitleTextProps>(({ theme, showTitleIcon }) => ({
  color: "#212124",
  fontSize: theme.spacing(2),
  fontWeight: "700",
  lineHeight: theme.spacing(2.2),
  fontFamily: "LotusSmartHL",
  paddingLeft: showTitleIcon ? 0 : theme.spacing(1.5),
}));

export const RightContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
})) as typeof Box;

export const LeftContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
})) as typeof Box;
export const TitleIconContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginRight: theme.spacing(1),
  "& svg": {
    width: 20,
    height: 20,
  },
})) as typeof Box;

export const SeeAllContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginRight: theme.spacing(1),
  cursor: "pointer",
  transition: "opacity 0.2s",
  "&:active": {
    opacity: 0.6,
  },
}));

export const SeeAllText = styled(Typography)(({ theme }) => ({
  color: "#00BCB6",
  fontSize: theme.spacing(1.5),
  fontWeight: "500",
  lineHeight: theme.spacing(2.2),
  fontFamily: "LotusSmartHL",
  display: "flex",
  alignItems: "center"
})) as typeof Typography;
